import React from 'react';
import { predicateCategories } from '../../mockData';

const PredicateLegend = ({ activeFilter, onSelectFilter }) => {
  return (
    <div className="p360-legend-wrapper">
      <span className="p360-legend-title">Kategori Predikat:</span>
      {predicateCategories.map((cat) => {
        const isSelected = activeFilter === cat.id;
        return (
          <button
            key={cat.id}
            type="button"
            className={`p360-badge ${cat.id}`}
            onClick={() => onSelectFilter && onSelectFilter(isSelected ? null : cat.id)}
            style={{
              cursor: onSelectFilter ? 'pointer' : 'default',
              transform: isSelected ? 'scale(1.05)' : 'none',
              boxShadow: isSelected ? `0 0 0 2px ${cat.color}` : 'none',
            }}
          >
            <span className="p360-dot"></span>
            {cat.label}
          </button>
        );
      })}
    </div>
  );
};

export default PredicateLegend;
